import styled, { css } from 'styled-components'

const TRANSITION = '220ms ease'

const SEARCH_WIDTH = 640
const CONVERSATION_WIDTH = 1096
const CONVERSATION_MIN_HEIGHT = 688

const CONTENT_COLUMN_MAX_WIDTH = 728
const HEADER_ICON_SIZE = 32

interface IConversationAware {
  $isConversation: boolean
}

export const GlobalCommandModalShellStyled = styled.div<IConversationAware>`
  position: relative;
  display: grid;
  grid-template-areas:
    'header'
    'body'
    'footer';
  grid-template-rows: auto 1fr auto;
  grid-template-columns: minmax(0, 1fr);

  width: ${({ $isConversation }) =>
    $isConversation ? `${CONVERSATION_WIDTH}px` : `${SEARCH_WIDTH}px`};
  min-height: ${({ $isConversation, theme }) =>
    $isConversation
      ? `min(${CONVERSATION_MIN_HEIGHT}px, calc(100vh - ${theme.typography.pxToRem(96)}))`
      : '0'};
  max-width: 100vw;
  max-height: calc(100vh - ${(props) => props.theme.typography.pxToRem(96)});

  transition:
    width ${TRANSITION},
    min-height ${TRANSITION};

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

export const GlobalCommandModalHeaderStyled = styled.div`
  grid-area: header;
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.space.small};
  padding: ${(props) => props.theme.space.small}
    ${(props) => props.theme.typography.pxToRem(48)}
    ${(props) => props.theme.space.small} ${(props) => props.theme.space.medium};
  border-bottom: 1px solid
    ${(props) => props.theme.colors.content.secondaryBorder};
`

export const GlobalCommandModalHeaderIconStyled = styled.img.attrs({
  alt: '',
  'aria-hidden': true,
})`
  width: ${(props) => props.theme.typography.pxToRem(HEADER_ICON_SIZE)};
  height: ${(props) => props.theme.typography.pxToRem(HEADER_ICON_SIZE)};
  flex-shrink: 0;
`

export const GlobalCommandModalTitleStyled = styled.h2`
  margin: 0;
  font-family: ${(props) => props.theme.fontFamily.header};
  font-size: ${(props) => props.theme.typography.pxToRem(14)};
  font-weight: ${(props) => props.theme.fontWeights.semibold};
  line-height: ${(props) => props.theme.typography.pxToRem(24)};
  color: ${(props) => props.theme.colors.text.primary};
`

export const GlobalCommandModalCloseAreaStyled = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  padding: ${(props) => props.theme.space.small}
    ${(props) => props.theme.typography.pxToRem(8)} 0;
`

export const GlobalCommandModalBodyStyled = styled.div<IConversationAware>`
  grid-area: body;
  min-height: 0;

  overflow-y: auto;

  ${({ $isConversation }) =>
    $isConversation &&
    css`
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }
    `}
`

export const GlobalCommandModalBodyContentStyled = styled.div<IConversationAware>`
  ${({ $isConversation, theme }) =>
    $isConversation &&
    css`
      max-width: ${theme.typography.pxToRem(CONTENT_COLUMN_MAX_WIDTH)};
      margin: 0 auto;
      padding: 0 ${theme.space.medium} ${theme.space.large};
    `}
`

export const GlobalCommandModalFooterStyled = styled.div`
  grid-area: footer;
  padding: 0 ${(props) => props.theme.space.medium}
    ${(props) => props.theme.space.medium};
  display: flex;
  justify-content: center;
`

export const GlobalCommandModalFooterContentStyled = styled.div`
  width: 100%;
  max-width: ${(props) =>
    props.theme.typography.pxToRem(CONTENT_COLUMN_MAX_WIDTH)};
`
